function transformItem2Dto(item) {
  const dto = {
    description: item.description,
    name: item.name,
    roleID: item.id,
    rolePermissions: item.rolePermissions || []
  };
  return dto;
}

function transformDto2Item(dto) {
  const item = {
    description: dto.description,
    id: dto.roleID,
    name: dto.name,
    rolePermissions: dto.rolePermissions || []
  };
  return item;
}

export const apiOverrides = { transformItem2Dto, transformDto2Item };

export const storeExtensions = {
  actions: {}
};
